/* ============================================================
   SiliDog — collection filter sidebar enhancer.
   Adds, into Horizon's native .facets--vertical sidebar:
     • a "Filters" + "Clear all" header
     • a SHOP FOR shape switcher (real collection links)
     • a PRICE group (preset ranges + min/max, real filter params)
   Availability stays Horizon's own facet (untouched).
   Idempotent + re-runs via MutationObserver so it survives the
   AJAX facet re-render (Horizon morphs the facets on filter apply).
   ============================================================ */
(function () {
  'use strict';

  // Shape collections verified to exist (handle → product count is live-checked in admin).
  var SHAPES = [
    { label: 'All', handle: 'shop' },
    { label: 'Bones', handle: 'bones' },
    { label: 'Hearts', handle: 'hearts' },
    { label: 'Circles', handle: 'circles' },
    { label: 'SmartTags', handle: 'smarttags' },
    { label: 'SiliSliders', handle: 'silisliders' }
  ];

  // Price presets in the STORE currency (USD). SiliDog tags sit ~$24.
  var PRICE_PRESETS = [
    { label: 'Under $20', gte: '', lte: '20' },
    { label: '$20 – $30', gte: '20', lte: '30' },
    { label: '$30 – $50', gte: '30', lte: '50' },
    { label: '$50 & up', gte: '50', lte: '' }
  ];

  function currentHandle() {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  // Preserve the storefront-preview context on our own links so clicking a
  // SHOP FOR pill / Clear-all inside a theme preview never bounces to LIVE.
  function previewQs() {
    var cur = new URLSearchParams(location.search);
    var keep = new URLSearchParams();
    ['preview_theme_id', 'pb', '_fd'].forEach(function (k) { if (cur.has(k)) keep.set(k, cur.get(k)); });
    var s = keep.toString();
    return s ? '?' + s : '';
  }

  // Build a collection URL that keeps existing filter params but overrides price.
  function priceUrl(gte, lte) {
    var p = new URLSearchParams(location.search);
    // drop only the cache-bust helper + old price; KEEP preview_theme_id/pb so
    // a price click in a preview stays on the preview theme (not live Avada).
    ['v', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(function (k) { p.delete(k); });
    if (gte) p.set('filter.v.price.gte', gte);
    if (lte) p.set('filter.v.price.lte', lte);
    var qs = p.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function anyFilterActive() {
    var p = new URLSearchParams(location.search);
    var found = false;
    p.forEach(function (_v, k) { if (k.indexOf('filter.') === 0) found = true; });
    return found;
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function buildHeader() {
    var head = el('div', 'sdf-head');
    head.appendChild(el('span', 'sdf-head__title', 'Filters'));
    var clear = el('a', 'sdf-head__clear', 'Clear all');
    clear.href = location.pathname + previewQs(); // strips filters, keeps preview context
    if (!anyFilterActive()) clear.setAttribute('hidden', '');
    head.appendChild(clear);
    return head;
  }

  function buildShopFor() {
    var here = currentHandle();
    var g = el('div', 'sdf-group sdf-group--shopfor');
    g.appendChild(el('span', 'sdf-group__label', 'Shop for'));
    var pills = el('div', 'sdf-pills');
    SHAPES.forEach(function (s) {
      var a = el('a', 'sdf-pill' + (s.handle === here ? ' sdf-pill--active' : ''), s.label);
      a.href = '/collections/' + s.handle + previewQs();
      pills.appendChild(a);
    });
    g.appendChild(pills);
    return g;
  }

  function buildPrice() {
    var p = new URLSearchParams(location.search);
    var curGte = p.get('filter.v.price.gte') || '';
    var curLte = p.get('filter.v.price.lte') || '';
    var g = el('div', 'sdf-group sdf-group--price');
    g.appendChild(el('span', 'sdf-group__label', 'Price'));
    var list = el('div', 'sdf-price-presets');
    PRICE_PRESETS.forEach(function (pr) {
      var isActive = (pr.gte === curGte && pr.lte === curLte) && (pr.gte || pr.lte);
      var a = el('a', 'sdf-price-preset' + (isActive ? ' sdf-price-preset--active' : ''), pr.label);
      a.href = priceUrl(pr.gte, pr.lte);
      list.appendChild(a);
    });
    g.appendChild(list);
    // min / max
    var range = el('div', 'sdf-price-range');
    var min = el('input'); min.type = 'number'; min.placeholder = 'Min $'; min.min = '0'; min.value = curGte; min.className = 'sdf-min';
    var max = el('input'); max.type = 'number'; max.placeholder = 'Max $'; max.min = '0'; max.value = curLte; max.className = 'sdf-max';
    var go = el('button', 'sdf-price-range__go', 'Go'); go.type = 'button';
    go.addEventListener('click', function () {
      location.href = priceUrl(min.value.trim(), max.value.trim());
    });
    range.appendChild(min); range.appendChild(max); range.appendChild(go);
    g.appendChild(range);
    return g;
  }

  function enhance(sidebar) {
    if (!sidebar || sidebar.querySelector(':scope > .sdf-head')) return; // already built
    var form = sidebar.querySelector('facets-form-component, .facets__form-wrapper, form');
    // header + SHOP FOR go before the native facet form; PRICE goes after it.
    sidebar.insertBefore(buildHeader(), form || null);
    sidebar.insertBefore(buildShopFor(), form || null);
    // PRICE group only renders when the store's native price facet is live
    // (Search & Discovery -> Filters -> Price). Until then the preset URLs are
    // ignored by Shopify, so showing dead controls would mislead shoppers.
    // Auto-heals: the group appears on the next page load after the facet is enabled.
    var priceFacetLive = !!document.querySelector('input[name^="filter.v.price"], [data-facet*="price"]');
    if (priceFacetLive) {
      if (form && form.nextSibling) sidebar.insertBefore(buildPrice(), form.nextSibling);
      else sidebar.appendChild(buildPrice());
    }
  }

  function boot() {
    document.querySelectorAll('.facets--vertical').forEach(enhance);
  }

  function start() {
    boot();
    // Re-inject if Horizon's AJAX facet update wipes our nodes.
    var host = document.querySelector('.collection-wrapper, #MainContent, main') || document.body;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; boot(); });
    });
    mo.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
